<template>
  <div class="authApp">
    <!-- <div class="topHeader"> -->
    <HomeHeader class="topHeader" />
    <!-- </div> -->
    <div class="bottomBody">
      <!-- <div class="sidebarWrapper"> -->
      <Siderbar class="sidebarWrapper" :class="{collapse:isCollapse}" />
      <!-- </div> -->
      <div class="qs-view_wrapper" :class="{collapse:isCollapse}">
        <nav-list />
        <div class="qs-view_content">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HomeHeader from "./components/header";
import Siderbar from "./components/siderbar";
import NavList from "./components/navList";

export default {
  components: { HomeHeader, Siderbar, NavList },
  computed:{
    
    isCollapse: function () {
      return this.$store.getters.collapse;
    },
  }
};
</script>
<style lang="less">
.topHeader {
  position: fixed;
  top: 0;
  left: 0;
  height: 60px;
  width: 100%;
  background-color: #fff;
}
.bottomBody {
  height: calc(100vh - 60px);
  width: 100%;
  margin-top: 60px;
  overflow: hidden;
  border-top: 1px solid rgb(161, 159, 159);
  .sidebarWrapper {
    height: 100%;
    width: 260px;
    float: left;
    background-color: white;
    &.collapse{
      width: 51px;
    }
  }
  .qs-view_wrapper {
    float: left;
    height: 100%;
    background: #f0f2f5;
    width: calc(100% - 260px);
    &.collapse{
      width: calc(100% - 51px);
    }
    .qs-view_content {
      margin: 10px;
      background: #fff;
      height: calc(100% - 70px);
      border-radius: 6px;
      // padding: 6px;
    }
  }
}
</style>
